<template>
<transition name="fade">
  <div class="hand" v-if="judge" :style="{ 'z-index': modaldata.Zindex, }" @mousedown.stop @click="close($event)">
    <transition name="slide-fade">
      <div v-if="judgeInner" class="hand__dialog dialog">
        <div class="dialog__close" @click="closeModal">
          <i class="icon-popup-close"></i>
        </div>
        <div class="dialog__header">
          选择手势
        </div>
        <div class="dialog__main">
          <div class="tabs" v-loading="isShowLoading" v-if="!isEmptyCategory">
            <div class="tabs__tabs">
              <ul>
                <li :class="{'is-active': item.active}"
                  v-for="(item, i) in tabs" :key="i"
                  @click="activateTab(i)"
                >
                  {{item.name}}
                </li>
              </ul>
            </div>
            <div class="tabs__panel" v-bar ref="vbar" v-if="tabs && tabs.length">
              <div>
                <!-- v-if="activePanel && activePanel.length" -->
                <ul>
                  <li @click="cancelHand()">
                    <i class="icon-no-hand"></i>
                    <span>不使用手势</span>
                  </li>
                  <li v-for="(item, i) in activePanel" :key="i" @click="selectHand(item, i)"
                    v-show="item.thumbnailUrl_1"
                    :class="{'is-active': item._active}"
                  >
                    <img :src="$handleAssetsUrl(item.thumbnailUrl_1)" alt="">
                  </li>
                </ul>
                <!-- <div class="empty" v-if="activePanel && !activePanel.length">
                  <i class="icon-laihua-air"></i>
                  <div>空空如也~</div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="empty" v-if="isEmptyCategory">
            <i class="icon-laihua-air"></i>
            <div>空空如也~</div>
          </div>

        </div>
      </div>
    </transition>
  </div>
</transition>
</template>

<script>
import { mapGetters } from 'vuex'
import modal    from '../mixins/modal'
export default {
  mixins: [modal],
  data() {
    return {
      modalName: 'hand',
      tabs: [
        // {name: '热门', active: true, alias: 'hot'},
        // {name: '儿童', active: false, alias: 'kid'},
        // {name: '卡通', active: false, alias: 'cartoon'},
        // {name: '动物', active: false, alias: 'animal'},
      ],
      panels: {

      },
      activePanel: null,
      handFileName: '',
      isShowLoading: false,
      isEmptyCategory: false,
      judgeInner: false,
    }
  },
  computed: {
    activeTab () {
      return this.tabs.filter(v => v.active)[0] || {}
    },
    ...mapGetters([
      'SelectSprites_Msg',
      'SelectScenes_Msg',
      'StyleMsg',
    ]),
    ...mapGetters({
      storeHand: 'getHand'
    }),
    sprite () {
      return this.SelectSprites_Msg[0];
    }
  },
  watch: {
    StyleMsg (val) {
      if (typeof +val === 'number') {
        // this.getCategory()
        //   .then(({data: resData} = {}) => {
        //     let {data, code} = resData;
        //     this.tabs = [];
        //     Object.keys(data).forEach((key, i) => {
        //       this.tabs.push(data[key]);
        //       let tab = this.tabs[i]
        //       if (i === 0) {
        //         this.$set(tab, 'active', true)
        //       } else {
        //         this.$set(tab, 'active', false)
        //       }

        //       this.getHands({
        //         category: tab.id,
        //         index: i,
        //       })
        //     })
        //   })
      }
    },
    judge (val) {
      this.$nextTick(() => {
        this.judgeInner = val;
      });
      if (val) {
        this.getCategoryHands();
      } else {
        this.isShowLoading = true;
      }
    }
  },
  created () {
    // this.getCategoryHands();
  },
  methods: {
    close (ev) {
      if (ev.target === ev.currentTarget) {
        this.closeModal();
      }
    },
    getCategory () {
      return this.$http.get('/api/home/category', {
        params: {
          type: 7,
          // style: this.StyleMsg,
        }
      })
    },

    // 获取全部分类的手势
    getCategoryHands () {
      return this.getCategory()
        .then(({data: resData} = {}) => {
          let {data, code} = resData;
          if (this.isEmpty(data)) {
            this.isEmptyCategory = true;
            return;
          }
          this.tabs = [];
          // hand filename
          this.getHand();

          let matchCount = {
            count: 0
          }

          let tasks = []
          this.isShowLoading = true;

          Object.keys(data).forEach((key, i) => {
            this.tabs.push(data[key]);
            let tab = this.tabs[i]
            if (i === 0) {
              this.$set(tab, 'active', true)
            } else {
              this.$set(tab, 'active', false)
            }

            let task = this.getHands({
              category: tab.id,
              index: i,
              matchCount
            });
            tasks.push(task);
          })

          this.getHandsAll(tasks);
        })
    },
    getHands ({
      category,
      index,
      matchCount = {}
    } = {}) {
      this.$http.get('/api/common/material', {
        params: {
          type: 7,
          // style: this.StyleMsg,
          sOfPage: 24,
          fPage: 255,
          pIndex: 1,
          category
        }
      })
        .then((res) => {
          // return {
          // response: res,
          // index,
          // matchCount,
          // }
          myResolve({
            response: res,
            index,
            matchCount,
            category
          })
          // let { data, code } = res.data;
          // let hasActiveHand = false;
          // hasActiveHand = data.some((item) => {
          //   console.log(this.handFileName, 'hand data')
          //   let isMatch = item.url_1 === this.handFileName;
          //   item._active = isMatch;
          //   return isMatch;
          // });
          // console.log(data, 'hand data')
          // this.panels[category] = data;

          // if (hasActiveHand && matchCount.count === 0) {
          //   matchCount.count += 1;
          //   this.activateTab(index);
          //   this.activePanel = data || [];
          // }

          // if (!hasActiveHand && index === 0) {
          //   this.activateTab(index);
          //   this.activePanel = data || [];
          // }
        })
        .catch(err => {

        })

        var myResolve, myReject;
        return new Promise((resolve, reject) => {
          myResolve = resolve;
          myReject = reject;
        })
    },
    getHandsAll (tasks) {
      Promise.all(tasks)
        .then((resArr) => {
          resArr.forEach(({ index, matchCount, response, category } = {}, resIndex) => {
            let { data, code } = response.data;
            let hasActiveHand = false;
            hasActiveHand = data.some((item) => {
              // console.log(this.handFileName, 'hand data')
              let isMatch = item.url_1 === this.handFileName;
              item._active = isMatch;
              return isMatch;
            });
            // console.log(data, 'hand data')
            this.panels[category] = data;

            if (hasActiveHand && matchCount.count === 0) {
              matchCount.count += 1;
              this.activateTab(index);
              this.activePanel = data || [];
            }

            if (!hasActiveHand && index === 0) {
              this.activateTab(index);
              this.activePanel = data || [];
            }

            if (resIndex === resArr.length - 1) {
              this.isShowLoading = false;
            }

            if (resIndex === 0) {
              if (!this.storeHand) {
                let arr = response.data.data;
                let hand = arr[0] || {};
                let coords = hand.nibCoord_1.split(',');
                hand = {
                  url: this.$handleAssetsUrl(hand.url_1),
                  x: coords[0],
                  y: coords[1]
                }
                this.$store.commit('setHand', hand);
              }
            }
          })
        })
        .catch(err => {
          console.warn(err)
          this.isShowLoading = false;
        })
    },
    activateTab (index) {
      this.tabs.forEach((v, i) => {
        if (i === index) {
          v.active = true;
          this.$set(v, 'active', true);
          this.activePanel = this.panels[v.id] || [];
        } else {
          v.active = false;
          this.$set(v, 'active', false);
        }
      });
    },
    selectHand (item, index) {
      let inout = this.modaldata.data.inout;
      // 选择手势
      let arr = item.nibCoord_1.split(',')
      let opts = {};
      opts[inout === 'in' ? 'entranceAnim' : 'exitAnim'] = {
        hand: {
          url: this.$handleAssetsUrl(item.url_1),
          x: arr[0],
          y: arr[1]
        }
      }
      // this.SelectSprites_Msg[0].updateEffect(opts, true);
      this.SelectSprites_Msg && this.SelectSprites_Msg.map(v => v.updateEffect(opts, true));
      this.$set(this.activePanel[index], '_active', true);
      this.closeModal();
      // 弹出气泡提示
      this.$bus.emit('showTips', {
        text: '选择好手势后，点击画布下方的“预览”可看效果哦！',
        position: {
          top: '500px',
          right: '280px'
        }
      });
    },
    getActivePanel ({
      id
    } = {}) {
      return this.panels[id] || [];
    },
    getHand () {
      if (!this.sprite) {
        return;
      }
      let inout = this.modaldata.data.inout;
      let selector = inout === 'in' ? '[id^="sprite-enter-hand-"]' : '[id^="sprite-exit-hand-"]';
      let jqEl = this.sprite.effect.hand;
      let url
      try {
        url = jqEl.find(selector + ' img').prop('src');
      } catch (err) {
        let hand = inout === 'in'
          ? this.sprite.effect.entranceAnim.hand
          : this.sprite.effect.exitAnim.hand;
        url = (hand || {}).url;
      }
      if (!url) {
        this.handFileName = '';
        return;
      }
      let parts = url.split('/');
      let filename = parts.slice(-2).join('/');
      this.handFileName = filename;
      return filename
    },
    cancelHand () {
      let inout = this.modaldata.data.inout;
      let opts = {};
      opts[inout === 'in' ? 'entranceAnim' : 'exitAnim'] = {
        hand: null
      }
      // this.SelectSprites_Msg[0].updateEffect(opts, true);
      this.SelectSprites_Msg && this.SelectSprites_Msg.map(v => v.updateEffect(opts, true));
      this.closeModal();
    },
    isEmpty (value) {
      if (value == null) {
        return true;
      }
      if (Array.isArray(value)) {
        return !value.length;
      }
      for (const key in value) {
        if (({}).hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors";
@import "../../style/transition";

.hand {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  &__dialog {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 680px;
    height: 462px;
  }
}

.dialog {
  &__close {
    position: absolute;
    top: 0;
    right: 0;
    height: 34px;
    line-height: 34px;
    padding-right: 13px;
    padding-left: 13px;
    cursor: pointer;
  }
  &__header {
    height: 34px;
    line-height: 34px;
    border-radius: 4px 4px 0 0;
    background-color: $c1;
    text-indent: 18px;
    text-align: left;
  }
  &__main {
    border-radius: 0 0 4px 4px;
    height: 428px;
    background-color: $c0;
    padding: 30px 38px;
    overflow-y: hidden;
  }
}

.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  & > div {
    margin-top: 20px;
  }
}

.tabs {
  &__tabs {
    margin-bottom: 27px;
    & > ul {
      display: flex;
      flex-wrap: wrap;
      & > li {
        min-width: 52px;
        padding: 3px 5px;
        margin-right: 36px;
        border-radius: 4px;
        cursor: pointer;
        &.is-active {
          background-color: $c2;
          color: $c0;
        }
        &:hover {
          background-color: $c2;
          color: $c0;
        }
      }
    }
  }

  &__panel {
    height: 330px;
    & > div {
      // width: (120 * 4 + 44 * 3 + 15) * 1px !important;
      // height: 330px + 17px !important;
      height: calc(100% + 16px) !important;
    }
    & > div > ul {
      display: flex;
      flex-wrap: wrap;
      // width: (120 * 4 + 44 * 3) * 1px;
      // margin-left: -4px;
      margin: 4px;
      & > li {
        width: 120px;
        height: 120px;
        margin-bottom: 47px;
        margin-right: 38px;
        box-shadow: 0 0 0 2px #ececfa;
        cursor: pointer;
        &:nth-child(4n) {
          margin-right: 0;
        }

        &.is-active {
          box-shadow: 0 0 0 2px $c2;
        }

        & > img {
          height: 100%;
          text-align: center;
        }

        &:first-of-type {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &>span {
            margin-top: 15px;
            color: $c14;
            cursor: default;
          }
        }
      }
    }
    & > div > .empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      & > div {
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/hand.vue